import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

// Whitelist af e-mails der må oprette sig
const ADMIN_EMAILS = [
  'christian.c.nielsen@gmail.com',
  'Mollelysgaard@hotmail.com',
  'kasper.anthon.soerensen@gmail.com',
  'Martindyrmanhansen@gmail.com',
  'mlundk@gmail.com',
  'kildetoft@fastmail.com',
];

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [mode, setMode] = useState('login'); // 'login' eller 'signup'
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!ADMIN_EMAILS.includes(email.trim().toLowerCase())) {
      setError('Denne e-mail har ikke adgang. Kontakt administrator.');
      return;
    }
    if (mode === 'signup') {
      // Opret bruger
      const { data, error } = await supabase.auth.signUp({ email, password });
      if (error) setError(error.message);
      else setSuccess('Bruger oprettet! Tjek din e-mail og klik på bekræftelseslinket for at aktivere din bruger. Du kan først logge ind, når du har bekræftet din e-mail.');
    } else {
      // Log ind
      const { data, error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError(error.message);
      else onLogin(data.user);
    }
  };

  return (
    <div style={{
      maxWidth: 400,
      margin: '60px auto',
      padding: 24,
      background: mode === 'signup' ? '#f7fbe7' : '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 16px #0001'
    }}>
      <h2 style={{ textAlign: 'center', marginBottom: 24 }}>
        {mode === 'signup' ? '📝 Opret bruger' : '🔑 Log ind'}
      </h2>
      <form onSubmit={handleSubmit}>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-mail (skal være whitelisted)" required style={{ width: '100%', marginBottom: 12, padding: 8, borderRadius: 6, border: '1px solid #bbb' }} />
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Kodeord" required style={{ width: '100%', marginBottom: 12, padding: 8, borderRadius: 6, border: '1px solid #bbb' }} />
        <button type="submit" style={{ width: '100%', padding: 10, borderRadius: 6, background: '#3a6ea5', color: '#fff', border: 'none', fontWeight: 600, fontSize: 16, marginBottom: 8 }}>
          {mode === 'signup' ? 'Opret bruger' : 'Log ind'}
        </button>
      </form>
      <div style={{ textAlign: 'center', marginTop: 8 }}>
        {mode === 'login' ? (
          <span>Har du ikke en bruger?{' '}
            <button onClick={() => { setMode('signup'); setError(''); setSuccess(''); }} style={{ background: 'none', border: 'none', color: '#3a6ea5', textDecoration: 'underline', cursor: 'pointer' }}>Opret dig</button>
          </span>
        ) : (
          <span>Har du allerede en bruger?{' '}
            <button onClick={() => { setMode('login'); setError(''); setSuccess(''); }} style={{ background: 'none', border: 'none', color: '#3a6ea5', textDecoration: 'underline', cursor: 'pointer' }}>Log ind</button>
          </span>
        )}
      </div>
      {error && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
      {success && <div style={{ color: 'green', marginTop: 12 }}>{success}</div>}
      <div style={{ color: '#888', fontSize: 13, marginTop: 16, textAlign: 'center' }}>
        Du forbliver logget ind på denne enhed indtil du aktivt logger ud.
      </div>
    </div>
  );
} 